export default "/images/vendor/flag-icon-css/flags/1x1/gb-sct.svg?bea4865f11865ef5646547efd1a78c32";